import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidComment",
  "use": "SolidComment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"SolidComment\">\n    <g fill-rule=\"evenodd\">\n        <path d=\"M11,18.863961 L4,11.7928932 L11,4.72182541 L11,9 C17,10.6666667 20,14.1666667 20,19.5 C18.6666667,16.8333333 15.6666667,15.3333333 11,15 L11,18.863961 Z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol